import React from 'react';
import { Link, Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSalesPointOfSale } from '../../contexts/SalesPointOfSaleContext';

const POS_GATED_PATHS = ['/ventas/quotes', '/ventas/service-orders', '/ventas/orders', '/ventas/continuous-services', '/ventas/documents'];

export function isVentasPosGatedPath(pathname) {
  return POS_GATED_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
}

const SalesPosBanner = () => {
  const { selectedPointOfSale } = useSalesPointOfSale();
  const location = useLocation();
  if (!selectedPointOfSale?.id) return null;

  return (
    <div className="bg-teal-50 border-b border-teal-100 px-6 py-2 flex flex-wrap items-center justify-between gap-2 text-sm">
      <span className="text-teal-900">
        Punto de venta:{' '}
        <strong>
          {selectedPointOfSale.code ? `${selectedPointOfSale.code} — ` : ''}
          {selectedPointOfSale.name}
        </strong>
      </span>
      <Link
        to="/ventas/select-pos"
        state={{ from: location.pathname }}
        className="text-teal-700 hover:text-teal-900 font-medium underline-offset-2 hover:underline"
      >
        Cambiar punto de venta
      </Link>
    </div>
  );
};

/**
 * Cotización, servicios y documentos exigen pasar por /ventas/select-pos en cada ingreso
 * (no reutilizar el POS guardado en sesión sin elegirlo de nuevo).
 */
const SalesPosGate = () => {
  const { selectedPointOfSale } = useSalesPointOfSale();
  const location = useLocation();
  const posConfirmed = location.state?.posConfirmed === true;

  if (!posConfirmed || !selectedPointOfSale?.id) {
    return (
      <Navigate
        to="/ventas/select-pos"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return (
    <>
      <SalesPosBanner />
      <Outlet />
    </>
  );
};

export default SalesPosGate;
